
import { defineComponent, getCurrentInstance, toRefs, reactive } from 'vue'
import { useStore } from '@/store/index'
import { currencyFormat } from '@/utils'
import router from '@/router'
import Keys from '@/constant/key'
import { joinParams } from '@/utils'
import { getChannelConfig,sendCode,getSecret } from '@/apis/channel'

export default defineComponent({
name: 'Partner',

setup() {
    const { proxy } = getCurrentInstance() as any
    const store = useStore()
    
    const userType = store.state.user.userInfo.user_type
    const data = reactive({
        channel_no:     store.state.user.userInfo.channel_no || '',   // 渠道号
        start_time:     null,   // 查询开始时间
        end_time:       null,   // 查询开始时间
        summary:        '',     // 概况数据
        tableData:      [],     // 列表数据
        channelList:    [],     // 渠道列表
        channelConfig: {
            test: {},
            formal: {}
        },
        dialogVisible:  false,  // 弹窗可见性
        code:           '',     // 验证码
        secret:         '',     // 密钥
        second:         0,      // 倒计时

        // 获取概况数据
        getSummary: () => {
            const {start_time, end_time, channel_no} = data
            proxy.$http.get(`/channel/admin_index?channel_no=${channel_no}&start_time=${start_time}&end_time=${end_time}`).then(res => {
                if(res.code == 200){
                    data.summary = res.data
                }else{
                    data.summary = ''
                    proxy.$message({type:'error',message:res.msg})
                }
            })
        },
        // 获取渠道列表
        getChannelList: () => {
            proxy.$http.get(`/dsapi/trade/channel_info`).then((res ) => {
                if(res.code == 200){
                    data.channelList = res.data;
                }else{
                    proxy.$message({type:'error',message:res.msg});
                }
            })
        },
        // 跳转添加渠道号
        onRedirect: (path) => {
            if (!data.channel_no) {
                return proxy.$message({
                    type: 'error',
                    message: '请选择查询渠道'
                })
            }
            router.push(`${path}?channel_no=${data.channel_no}`)
        },
        // 格式化货币
        cF: (val) => {
            return currencyFormat(val)
        },
        // 结算订单导出
        onSettleExport: () => {
            const { channel_no, start_time, end_time } = data
            if (!start_time || !end_time) {
                return proxy.$message({
                    type: 'error',
                    message: '请选择导出时间段'
                })
            }

            window.open(`${Keys.baseUrl}/channel/export_order?${joinParams({channel_no, start_time, end_time})}`)
        },
         // 获取渠道配置信息
        initData: async () => {
            const { code, data: configData, msg } = await getChannelConfig() as any
            if (code != 200) return proxy.$message({ type: 'error', message: msg })
            data.channelConfig = configData
        },
         // 关闭弹框前清空数据
        beforeDialogClose:() => {
            data.code = ''
            data.second = 0
            data.dialogVisible = false
        },
        // 发送验证码
        onSendCode: async () => {
            const { code, msg } = await sendCode() as any
            if (code != 200) return proxy.$message({ type: 'error', message: msg })
            proxy.$message({ type: 'success', message: '验证码发送成功，5分钟内有效' })
            data.doCountDown()
        },
        // 倒计时
        doCountDown : () => {
            data.second = 60
            const timer = setInterval(() => {
                data.second > 0 ? data.second-- : clearInterval(timer)
            }, 1000)
        },
        // 获取密钥
        onGetSecret: async () => {
            const { code, data: secretData, msg } = await getSecret(data.code) as any
            if (code != 200) return proxy.$message({ type: 'error', message: msg })
            data.secret = secretData.apikey
        }
    })
    
    if (data.channel_no) {
        data.getSummary();
        data.initData()
    } else {
        data.getChannelList()
    }
    return { userType, ...toRefs(data)}
}
})
